<template>
  <a class="c-link-card" :class="{ vertical }" :href="linkItem.url">
    <div class="c-link-card__image" :class="{ vertical }" ref="image">
      <img :src="linkItem.image.src" :alt="linkItem.title" />
      <span
        class="c-link-card__new-label"
        :class="{ vertical }"
        v-if="showNewLabel && linkItem.isNew"
        >新着</span
      >
      <ul v-if="linkItem.labels.length" class="c-link-card__labels">
        <li
          v-for="label in linkItem.labels"
          :key="label"
          class="c-link-card__label"
        >
          <span>{{ label }}</span>
        </li>
      </ul>
    </div>
    <div class="c-link-card__container" :class="{ vertical }">
      <div class="c-link-card__title-container">
        <p v-if="showTitle" class="c-link-card__title" :class="{ ellipsis }">
          {{ linkItem.title }}
        </p>
        <div v-if="favouriteType" class="c-link-card__heart">
          <f-heart
            :id="linkItem.id"
            :handle="linkItem.handle"
            :is-favourite="isFavourite"
            size="large"
            :type="favouriteType"
            @heart-changed="isFavourite = $event"
          ></f-heart>
        </div>
      </div>
      <time :datetime="linkItem.publishedAt" v-if="showDate">{{
        linkItem.dateText
      }}</time>
      <div
        v-if="shouldShowTags && linkItem.tags.length"
        class="c-link-card__tags"
      >
        <span v-for="tag in filteredTags" :key="tag" class="c-link-card__tag">{{
          tag
        }}</span>
      </div>
      <div v-if="textBottom" class="c-link-card__text-bottom">
        {{ textBottom }}
      </div>
    </div>
  </a>
</template>

<script>
import { LinkItem } from '~/js/models/linkItem'
import FHeart from '~/js/components/heart'

export default {
  name: 'ComponentLinkCard',
  components: {
    FHeart,
  },
  props: {
    linkItem: { type: LinkItem },
    ellipsis: { type: Boolean, default: true },
    height: { type: Number, default: null },
    favouriteType: { type: String, default: null },
    ratio: { type: Number, default: 1 },
    shouldShowTags: { type: Boolean, default: false },
    showDate: { type: Boolean, default: false },
    showNewLabel: { type: Boolean, default: false },
    showTitle: { type: Boolean, default: true },
    textBottom: { type: String, default: '' },
    vertical: { type: Boolean, default: false },
  },
  data() {
    return {
      isFavourite: this.linkItem.isFavourite,
    }
  },
  mounted() {
    if (this.height) this.$refs.image.style.paddingTop = `${this.height}px`
    else if (!this.vertical)
      this.$refs.image.style.paddingTop = `${100 / this.ratio}%`
  },
  computed: {
    filteredTags() {
      return this.linkItem.tags.filter((tag) => tag.trim().startsWith('#'))
    },
  },
}
</script>

<style lang="scss" scoped>
@use '~/scss/generic/variables';

%label {
  border-radius: 20px;
  color: #fff;
  font-size: 11px;
  padding: 3px 10px;
  word-break: keep-all;
}

.c-link-card {
  border-radius: 8px;
  display: block;
  height: 100%;
  transition: 0.3s;

  &.vertical {
    display: flex;
  }

  &:hover {
    opacity: 0.7;
  }

  &__image {
    padding-top: 100%;
    position: relative;
    width: 100%;

    &.vertical {
      width: 80px;
      flex-shrink: 0;
      margin-right: 12px;
      padding-top: 80px;
    }

    img {
      border-radius: 8px;
      height: 100%;
      left: 0;
      object-fit: cover;
      position: absolute;
      top: 0;
      width: 100%;
    }
  }

  &__new-label {
    @extend %label;
    background-color: variables.$color-accent;
    left: 10px;
    position: absolute;
    top: 10px;

    &.vertical {
      left: 5px;
      top: 5px;
    }
  }

  &__labels {
    align-items: flex-end;
    bottom: 10px;
    display: flex;
    left: 10px;
    flex-wrap: wrap-reverse;
    margin: -2px;
    position: absolute;
  }

  &__label {
    padding: 2px;
    line-height: 1;

    span {
      @extend %label;
      background-color: variables.$color-brown;
    }
  }

  &__container {
    &:not(.vertical) {
      margin-top: 8px;
    }
  }

  &__title-container {
    display: flex;
  }

  &__title {
    flex-grow: 1;
    font-size: 13px;
    font-weight: 600;

    &.ellipsis {
      display: -webkit-box;
      overflow: hidden;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }

  &__heart {
    margin-left: 8px;
  }

  &__tags {
    margin-top: 10px;
  }

  &__text-bottom {
    display: none;
    color: variables.$color-brown;
    font-size: 13px;
    font-weight: 600;
    margin-top: 2px;

    @media #{variables.$mobile} {
      display: block;
    }
  }
}
</style>
